import { Tooltip } from "../../components"; // adjust path based on your file structure
import React, { useState } from "react";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { FaSpinner } from "react-icons/fa";
import { environment } from "../../config/config";

const ComponentCostDetails = ({
  quantity,
  component,
  differ,
  accountType,
  componentIndex,
  itemOpenIndex,
  activeUnitIndex,
  project,
  setProject,
  setActiveComponentIndex,
  setGeneratedItems,
  fetchGeneratMaterials,
  value,
  setInstructionValue
}) => {

  const [isLoading, setIsLoading] = useState(false);

  const calculateCost = () => {
    const cost = parseFloat(
      Math.round(Number(quantity) * Number(component["rate"] || 0))
    )
      .toFixed(2)
      .replace(/\.00$/, ".00");

    return cost;
  };

  const handleClick = async () => {
    setActiveComponentIndex(componentIndex);

    let firmData = JSON.parse(localStorage.getItem("User"));

    if (environment === "staging" || firmData.Firm === 'remole') {

      const componentProperties =
        project?.rooms[itemOpenIndex]?.Units[activeUnitIndex]?.Components[
          componentIndex
        ];

      if (!componentProperties) return;

      const hasWork = componentProperties.Work?.length > 0;
      const hasMaterial = componentProperties.Material?.length > 0;

      if (hasWork || hasMaterial) {
        const shouldRegenerate = window.confirm(
          "This component already has vendor Work or Material data. Do you want to regenerate a new material set?"
        );
        if (!shouldRegenerate) return;
      }

      try {
        setIsLoading(true);

        componentProperties['user_instruction'] = value ? value : '';

        const generatedMaterials = await fetchGeneratMaterials(
          componentProperties
        );

        const updatedProject = JSON.parse(JSON.stringify(project)); // Deep clone
        const componentPath =
          updatedProject.rooms[itemOpenIndex].Units[activeUnitIndex].Components[
            componentIndex
          ];

        // Clear old data first
        componentPath.Work = [];
        componentPath.Material = [];
        setProject(updatedProject); // update immediately with cleared data

        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        for (const work of generatedMaterials.work || []) {
          componentPath.Work.push(work);
          setProject(JSON.parse(JSON.stringify(updatedProject)));
          await delay(500);
        }

        // Add Material items one by one
        for (const material of generatedMaterials.material || []) {
          componentPath.Material.push(material);
          setProject(JSON.parse(JSON.stringify(updatedProject)));
          await delay(500);
        }

        setGeneratedItems(generatedMaterials);
        setInstructionValue('');
      } catch (error) {
        console.error("Failed to fetch materials:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        transition: "all 0.3s ease-in-out",
        gap: "8px",
      }}
    >
      <div
        style={{
          cursor: "pointer",
          fontWeight: "700",
          fontSize: "small",
        }}
      >
        INR {calculateCost()}
      </div>

      {accountType !== "BOQ" && (
        <div
          style={{
            color: differ?.percentage > 0 ? "red" : "green",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
          }}
        >
          {differ?.percentage &&
            (differ.percentage > 0 ? <AiFillCaretDown /> : <AiFillCaretUp />)}
          {differ?.value || ""}
          {differ?.percentage
            ? ` (${differ.percentage.toString().replace("-", "")}%)`
            : ""}
        </div>
      )}

      <Tooltip
        content="Click to add vendor details for work and material"
        width={200}
        left={-100}
      >
        <div
          onClick={handleClick}
          style={{
            color: "#275571",
            fontSize: "12px",
            fontWeight: "bold",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            transition: "opacity 0.3s ease-in-out",
            opacity: isLoading ? 0.6 : 1,
          }}
        >
          Add Vendors {">>"}
          {isLoading && (
            <FaSpinner
              className="spin"
              style={{
                animation: "spin 0.8s linear infinite",
                fontSize: "14px",
              }}
            />
          )}
        </div>
        {isLoading && (
          <p style={{ fontSize: 12, fontWeight: "600", marginTop: 5 }}>
            generating items...
          </p>
        )}
      </Tooltip>

      {/* Spinner animation */}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ComponentCostDetails;
